import React from 'react'
import '@/app/ui/components/Badge.css'

// Badge Variants
type BadgeVariant = 'default' | 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info'

// Badge Sizes
type BadgeSize = 'xs' | 'sm' | 'md' | 'lg'

// Badge Styles
type BadgeStyle = 'solid' | 'soft' | 'outline'

interface BadgeProps {
  children: React.ReactNode
  platform?: string
  variant?: BadgeVariant
  size?: BadgeSize
  style?: BadgeStyle
  icon?: string
  iconPosition?: 'left' | 'right'
  rounded?: boolean
  removable?: boolean
  onRemove?: () => void
  dot?: boolean
  dotColor?: string
  pulse?: boolean
}

// Platform to variant mapping
const platformVariants: { [key: string]: BadgeVariant } = {
  'Web': 'primary',
  'Mobile': 'info',
  'Admin': 'danger',
  'Supplier': 'success',
  'Customer': 'warning',
  'Panel': 'default',
  'ERP': 'secondary'
}

export function Badge({
  children,
  platform,
  variant,
  size = 'sm',
  style = 'solid',
  icon,
  iconPosition = 'left',
  rounded = false,
  removable = false,
  onRemove,
  dot = false,
  dotColor,
  pulse = false
}: BadgeProps) {
  // If platform is provided, use platform variant
  const finalVariant = platform ? (platformVariants[platform] || 'default') : (variant || 'default')

  return (
    <span 
      className={`badge badge--${finalVariant} badge--${size} badge--${style} ${rounded ? 'badge--rounded' : ''} ${dot ? 'badge--with-dot' : ''}`}
    >
      {dot && (
        <span 
          className={`badge-dot ${pulse ? 'badge-dot--pulse' : ''}`} 
          style={dotColor ? { background: dotColor } : undefined}
        />
      )}
      {icon && iconPosition === 'left' && <i className={icon} />}
      <span className="badge-text">{children}</span>
      {icon && iconPosition === 'right' && <i className={icon} />}
      {removable && (
        <button className="badge-remove" onClick={onRemove} type="button">
          <i className="fa-duotone fa-xmark" />
        </button>
      )}
    </span>
  )
}
